<template>
	<div class="chat-container w-100 position-relative bg-white">
	<div id="profie"></div>
		<div class="position-relative z-index-1028">
      <div class="row no-gutters justify-content-center">
        <div class="fixed-top d-block nav-bottom">
          <div class="custom-container-fluid px-0">
            <div class="row justify-content-center no-gutters">
              <div class="col-xl-4 col-lg-4 col-md-6 col-sm-8 col-12 position-relative">
                <div class="bg-white box-shadow-nav">
                  <div class="container px-4 w-100 pt-1 pb-2">
                    <div class="row no-gutters py-2 m-0 w-100">
                      <div class="col-1">
                        <div class="">
                          <router-link :to="'/'+getMerchant().code+'/concierge'">
                            <img src="../../../../assets/img/icon/back-arrow.png" class="mt-1" width="15">
                          </router-link>
                        </div>
                      </div>
                      <div class="col-9">
                        <div class="">
                          <p class="mb-0 body-1-2 nav-hotel ml-3 mt-1">{{$t('hotel.menu.account')}}</p>
                        </div>
                      </div>
                      <!-- <div class="col-2 text-right">
          							<router-link :to="'/'+getMerchant().code+'/concierge/notification'">
                          <img src="../../../../assets/img/icon/notif.png" class="mt-1" width="20">
                        </router-link>
                      </div> -->
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div style="margin-top: 55px"></div>
    <div class="w-100 px-4 pt-4">
      <router-link :to="'/'+getMerchant().code+'/concierge/account/personal-data'">
	    	<div class="row slim-grid-row">
	    		<div class="col-12 align-self-center">
	    			<div class="d-inline-block align-middle mr-3">
	    				<div class="border-profil border-2-green bg-white rounded-50 mx-auto mb-0 cursor-pointer">
	    					<img :src="getCurrentUser().avatar" class="rounded-50 img-profil d-block m-auto">
	    				</div>
	    			</div>
	    			<div class="d-inline-block align-middle" style="width: 60%;">
		    			<p class="mb-0 body-1-4 text-20 text-truncate">{{getCurrentUser().first_name+''+ (getCurrentUser().last_name != null ? getCurrentUser().last_name : '')}}</p>
		    			<p class="mb-0 body-2-2 text-truncate">{{getCurrentUser().email}}</p>
	    			</div>
	    		</div>
	    	</div>
	    </router-link>
    </div>
   <!--  <div class="container px-4">
    	<div class="row no-gutters text-center py__profile rounded-6 border">
    		<div class="col-6 border-right">
          <router-link :to="'/'+getMerchant().code+'/concierge/reward'">
	  				<p class="mb-0 body-2 text-14 font-regular">Points</p>
	  				<img src="../../../../assets/img/icon/concierge/point.png" width="17" class="d-inline-block position-relative" style="top: -2px">
	  				<div class="d-inline-block ml-1">
	  					<p class="mb-0 body-2-2 text-16 font-bold">100.000</p>
	  				</div>
	  			</router-link> 
    		</div>
    		<div class="col-6">
          <router-link :to="'/'+getMerchant().code+'/concierge/member/my-member'">
	    			<p class="mb-0 body-2 text-14 font-regular">Member</p>
	  				<img src="../../../../assets/img/icon/concierge/card-member.svg" width="17" class="d-inline-block position-relative" style="top: -1px">
	  				<div class="d-inline-block ml-1">
	  					<p class="mb-0 body-2-2 text-16 font-bold">Gold</p>
	  				</div> 
	  			</router-link>
    		</div>
    	</div>
    </div> -->
		<div class="p-4">
			<div class="mb-2 pt-3 pb-3 cursor-pointer border-bottom" v-for="menu in menus">
        <router-link :to="'/'+getMerchant().code+'/concierge/'+menu.url">
					<div class="row">
						<div class="col-10 align-self-center" :class="{'text-danger': menu.title == 'Logout'}">
							<img :src="menu.img" width="14" class="mr-3 object-fit" v-if="menu.img != ''">
							<i class="d-inline-block align-middle mr-3 body-2-2 text-16 bold" :class="menu.icon" :style="{color: menu.color}" v-else></i>
							<p class="mb-0 d-inline-block align-middle body-2-2 text-16 font-semibold text-dark" :class="{'text-danger': menu.title == 'Logout'}">{{menu.title}}</p>
						</div>
						<div class="col-2 align-self-center text-right">
							<i class="simple-icon-arrow-right text-14 body-2-2" :class="{'text-danger': menu.title == 'Logout'}"></i>
						</div>
					</div>
				</router-link>
			</div>
			<div class="mb-2 pt-3 pb-3 cursor-pointer border-bottom">
        <router-link :to="'/'+getMerchant().code+'/feedback'">
					<div class="row">
						<div class="col-10 align-self-center">
							<i class="d-inline-block align-middle mr-3 body-2-2 text-16 bold simple-icon-star"></i>
							<p class="mb-0 d-inline-block align-middle body-2-2 text-16 font-semibold text-dark">{{$t('restaurant.menu.review')}}</p>
						</div>
						<div class="col-2 align-self-center text-right">
							<i class="simple-icon-arrow-right text-14 body-2-2"></i>
						</div>
					</div>
				</router-link>
			</div>
		</div>
		<bottom-navbar></bottom-navbar>
	</div>
</template>
<script>
	import MemberCard from '@/components/hotel/MemberCard'
	import BottomNavbar from '@/components/hotel/BottomNavbar';
	import {mapGetters} from "vuex";
	import iconHistory from "../../../../assets/img/icon/menu/icn_calendar__inactive.png";
	import {get} from '@/services/index.js'

	export default{
		components:{
			MemberCard,
			BottomNavbar
		},
		metaInfo(){
      return {
        title: 'Account',
        titleTemplate: this.getMetaTitleTemplate()
      }
    },
		data(){
			return{
				scrollPosition: null,
				card_type: 'gold',
				menus: [
					{
						title: this.$t('hotel.menu.personal-data'),
						icon: 'simple-icon-user',
						url: 'account/personal-data',
						img: '',
					},
					{
						title: this.$t('hotel.menu.history'),
						icon: 'simple-icon-event',
						url: 'order',
						img: '',
					},
					// {
					// 	title: this.$t('hotel.menu.help'),
					// 	icon: 'simple-icon-question',
					// 	url: 'account/help',
					// 	img: '',
					// },
					{
						title: this.$t('hotel.menu.language'),
						icon: 'simple-icon-settings',
						url: 'account/language',
						img: '',
					}
					// {
					// 	title: 'Logout',
					// 	icon: 'simple-icon-logout',
					// 	url: 'account',
					// 	img: '',
					// 	color: '#dc3545'
					// }
				]
			}
		},
		mounted() {
      window.addEventListener('scroll', this.updateScroll);
      document.getElementById('profie').scrollIntoView({
        behavior: 'smooth'
      });
      this.checkStatusMember()
		},
		methods:{
			...mapGetters(['getMerchant','getCurrentUser','getMetaTitleTemplate']),
			updateScroll() {
          this.scrollPosition = window.scrollY
      },
			changeCardMember(){
				this.card_type = (this.card_type == 'platinum') ? 'gold' : 'platinum'
			},
			checkStatusMember(){
        get("CONCIERGE","membership/user-member-card-detail",{
          merchant_id: this.getMerchant().id
        }).then(response=>{
          let res = response.data
        	if(res.code == 'MEMBER' && this.getMerchant().use_membership){
        		this.menus.splice(1,0,{
        			title: this.$t('hotel.menu.my-reward'),
							icon: 'simple-icon-badge',
							url: 'member?scrollTo=reward_list',
							img: '',
        		})
        	}
        })
      },
		}
	}
</script>
<style>
	.border-profil{
		width: 70px;
    height: 70px;
    padding: 3px 0;
    border-radius: 100%!important;
	}

	.py__profile{
		padding: 16px 0!important;
	}

	@media screen and (max-width: 655px) {
		.py__profile{
			padding: 10px 0!important;
		}
	}


</style>


// WEBPACK FOOTER //
// src/pages/hotel/concierge/account/Account.vue